import * as React from 'react'
import { ReactElement } from 'react'
import { TaskAction, TaskMutationDto } from '../../config/taskConfig'
import AddEntityForm from '../../components/Form/AddEntityForm'
import TaskForm from '../../components/Form/Task/TaskForm'
import { EntityFormPage } from '../../components/Form/Form'
import useAxios from '../../hooks/useAxios'

export default function AddTask(props: EntityFormPage): ReactElement {
    const axios = useAxios()
    return (
        <AddEntityForm<TaskMutationDto, TaskMutationDto>
            {...props}
            form={TaskForm}
            addEntity={values => ({
                type: TaskAction.Add,
                payload: axios.post('/task', values),
            })}
            getResetValues={(initialValues: TaskMutationDto, values: TaskMutationDto) => ({
                ...initialValues,
                due: values.due,
                fileId: values.fileId,
                assigneeId: values.assigneeId,
                assignerId: values.assignerId,
            })}
        />
    )
}
